export default function TeamSection() {
  return (
    <section id="team" className="bg-[#F8F4E8] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          {/* Photo */}
          <div className="w-5/12">
            <div className="relative">
              <div className="bg-white p-2 rounded-2xl shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/b58db08d6a96acaa3da3fd276a2b6039.jpg"
                  alt="Mehmet Alp Yalinpala"
                  className="w-full h-auto rounded-xl object-cover object-top"
                  style={{ aspectRatio: '3/4' }}
                />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-7/12">
            <div className="inline-block bg-[#D4745E] text-white px-4 py-2 rounded-full mb-6">
              <span className="text-xs font-bold tracking-widest" style={{ fontFamily: 'Montserrat, sans-serif' }}>TEAM LEADER</span>
            </div>

            <h2 className="text-5xl font-bold text-[#2B2D42] mb-3 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Мехмет Альп Ялынпала
            </h2>
            <p className="text-xl font-semibold text-gray-600 mb-7" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Mehmet Alp Yalinpala
            </p>

            <p className="text-lg font-semibold text-gray-600 mb-7" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Главный инженер / Технический директор
            </p>

            <p className="text-base leading-relaxed text-gray-700 mb-10 max-w-xl" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Инженер-строитель с 21-летним международным опытом. Специализируется на проектировании и реализации сложных инженерных объектов в сфере коммерческой и жилой недвижимости. Руководил строительством более 150 проектов в 8 странах, включая Турцию, ОАЭ, Россию и страны Европы.
            </p>

            {/* Statistics */}
            <div className="grid grid-cols-3 gap-8">
              <div>
                <p className="text-5xl font-bold text-[#D4745E] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>21</p>
                <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>Лет опыта</p>
              </div>
              <div>
                <p className="text-5xl font-bold text-[#D4745E] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>150+</p>
                <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>Проектов</p>
              </div>
              <div>
                <p className="text-5xl font-bold text-[#D4745E] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>8</p>
                <p className="text-sm text-gray-600" style={{ fontFamily: 'Montserrat, sans-serif' }}>Стран</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
